import { render, staticRenderFns } from "./ExternalVeikkaus.vue?vue&type=template&id=50847ffe&"
import script from "./ExternalVeikkaus.vue?vue&type=script&lang=js&"
export * from "./ExternalVeikkaus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports